import React from 'react';
import { motion } from 'framer-motion';
export function Vision() {
  return <section className="py-24 px-6 bg-zinc-950" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-119">
          <p className="text-2xl md:text-4xl font-serif leading-snug text-zinc-200" data-id="element-120">
            Dance for Fans is a fresh, dynamic platform designed for creators
            and fans who share a passion for movement, expression, and art.
          </p>

          <div className="space-y-8 text-lg md:text-xl text-zinc-400 font-light leading-relaxed" data-id="element-121">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-122">
              Whether you're into contemporary dance, hip-hop, or more niche
              forms of performance, we offer a dedicated space where performers
              can connect deeply with their audience and monetize their
              creativity.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-123">
              As a work in progress, Dance for Fans is constantly evolving. We
              listen to our community to enhance the experience, making sure
              that whether you're a fan of dance in its purest form or exploring
              more adult avenues of expression, you'll find your place here.{' '}
              <span className="text-zinc-200 font-medium" data-id="element-124">
                This is just the beginning.
              </span>
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}